<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { AvatarRoot } from 'reka-ui';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <AvatarRoot
        data-slot="avatar"
        :class="
            cn(
                'bg-background inline-flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full border align-middle select-none',
                props.class,
            )
        "
    >
        <slot />
    </AvatarRoot>
</template>
